module.exports = __webpack_public_path__ + "static/media/features_01.17d53ea5.png";